import type { ReactElement, ReactNode } from "react";

interface ElementWithBlocks {
  blocks?: unknown;
}

const isElementWithBlocksProps = (
  element: ReactElement,
): element is ReactElement<ElementWithBlocks> =>
  "blocks" in (element.props as object);

/**
 * Safely extracts blocks from children props in BuilderUI blocks
 * @param children - The children prop from a BuilderUI block
 * @returns The blocks array if available, undefined otherwise
 */
export const getBlocksFromChildren = (children: ReactNode): unknown => {
  if (!children || typeof children !== "object" || !("props" in children)) {
    return undefined;
  }

  const element = children as ReactElement;
  if (!isElementWithBlocksProps(element)) {
    return undefined;
  }

  return element.props.blocks;
};
